var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect, useCallback, useRef } from "react";
import { Pane, Button, Card, Row, Col, AccordionSet, Accordion, Checkbox, RadioButton, ErrorModal, Modal, ModalFooter, PaneFooter, Spinner, } from "@folio/stripes/components";
import { useQuery } from "react-query";
import moment from "moment";
import { FormattedMessage, useIntl } from "react-intl";
import { useHistory, useParams } from "react-router";
import { useOkapiKy } from "@folio/stripes/core";
import { useForm, Controller, useFieldArray, } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { createPublisherSchema, createZodErrorMap, } from "../../utils/validationUtils";
import { describeInvalidFields } from "../../utils/validationSummary";
import { isMultipleWorkSpecFormatsError, normalizeLoadedWorkSpecification, normalizeWorkSpecification, } from "../../utils/workSpecificationUtils";
import { WorkSpecFormatFields, } from "./WorkSpecFormatFields";
import { fetchAddressCode, lookupPublisherByCompanyNumber, fetchPublisherData, updatePublisher, fetchRegions, getDuplicities, fetchGuarantorByEmail, fetchMultiGuarantorByEmail, } from "../../api/publisherService";
import { AlternativeNameTypeSelect, RecekTextField, RecekSelect, RecekTextArea, RecekDatepicker, RecekSelection, } from "../../components/inputs";
import { hasAtLeastOneRole, hasRole, useActiveRoles, } from "../../utils/permissionsUtils";
import { isGuarantorsChangeForbiddenError, isPlainGuarantorInMyPublisher, } from "../../utils/myPublisherPermissions";
import { RoleEnum } from "../../types/RoleEnum";
import { normalizePublisherGuarantors, resolveGuarantorRole, toggleGuarantorRole, } from "../../utils/guarantorRoles";
import { ErrorType } from "../../types/ErrorType";
import { useAddressSuggest } from "../../hooks/useAddressSuggest";
import { resolveAresLookupErrorMessage } from "../../utils/aresLookupError";
import DuplicateTable, { DuplicateDetailPane, useDuplicateTable, } from "../../components/DuplicateTable";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { AuthorityAuthorRow } from "../../components/AuthorityAuthorRow";
import { searchAuthorityAuthors } from "../../api/authorityAuthorService";
import { personIdsLinkedElsewhere, unlinkedAuthor, } from "../../utils/authorityAuthorUtils";
import { scrollToError, useScrollOnPotentialDuplicates, } from "../../utils/scrollUtils";
import { parentPathOfAction } from "../../utils/urlUtils";
import { dirtyArrayItems } from "../../utils/dirtyFieldsUtils";
import WarningModal from "../../components/WarningModal";
import RenderField from "../../components/RenderField";
import { formatRegistrationsSummary, getActiveRegistrations, hasActiveNonOneOffRegistration, hasOneOffRegistrationReactivatedByRestore, shouldShowWorkSpecSection, } from "../../utils/registrationUtils";
import { hasApprovalFieldChanged } from "../../utils/publisherApprovalUtils";
import { prefillGuarantorRoles } from "../../utils/prefillGuarantorRoles";
import { hasServerErrorType, withServerErrorMessages, } from "../../utils/serverErrorUtils";
var PublisherEdit = function (_a) {
    var _b;
    var status = _a.status;
    var id = useParams().id;
    var history = useHistory();
    var ky = useOkapiKy();
    var activeRoles = useActiveRoles().roles;
    var formatMessage = useIntl().formatMessage;
    var _c = useState([]), potentialDuplicates = _c[0], setPotentialDuplicates = _c[1];
    var _d = useState(""), duplicateWarning = _d[0], setDuplicateWarning = _d[1];
    var _e = useState(false), duplicateModalOpen = _e[0], setDuplicateModalOpen = _e[1];
    // Optional reason captured only for the REJECT action; sent to the BE as
    // `rejectionReason` on the rejection PUT and rendered in the notification email.
    // The reject button opens a dialog first (see rejectModalOpen) so the reason
    // can actually be entered before the rejection is submitted.
    var _f = useState(""), rejectionReason = _f[0], setRejectionReason = _f[1];
    var _g = useState(false), rejectModalOpen = _g[0], setRejectModalOpen = _g[1];
    // Data + action awaiting the user's "Continue anyway" confirmation in the
    // duplicate warning; lets us finish the submit directly (no fragile 2nd click).
    var duplicateSubmitRef = useRef();
    // Guards the submit against double-clicks / races (disabled + spinner).
    var _h = useState(false), isSubmittingForm = _h[0], setIsSubmittingForm = _h[1];
    // Stable baseline for the approval-field change check. Captured ONCE from the
    // loaded publisher record at reset() time (see the `publisher` query onSuccess)
    // so it is immune to react-hook-form's re-registration churn on field-array
    // appends. The destructured `formState.defaultValues` proxy can read back
    // stale/empty at the moment runPreSubmitChecks runs, which made non-empty
    // approved fields (name, companyNumber, legalForm, …) compare against an empty
    // baseline and wrongly fire the "wait for approval" dialog after merely adding
    // a contact (board item DB-035 / Tools #74380).
    var approvalBaselineRef = useRef();
    var _j = useState({}), disableEmailField = _j[0], setDisableEmailField = _j[1];
    // the one-off title data must stay editable after approval so a publisher whose
    // title was not created can be fixed, and during a renewal (RESTORE);
    // on REJECT the fields stay read-only and the spec is not submitted
    var isWorkSpecEditable = status === "APPROVE" || status === "RESTORE" || status === "EDIT";
    // restore option "obnovit jako soustavné vydávání": the ONE_OFF registration
    // terminated by the close stays terminated and a CONTINUOUS one replaces it,
    // so the book (work specification) is neither shown, validated nor kept
    var _k = useState(false), restoreAsContinuous = _k[0], setRestoreAsContinuous = _k[1];
    var publisherSchema = createPublisherSchema(formatMessage, {
        validateWorkSpec: isWorkSpecEditable,
        restoreReactivatesRegistrations: status === "RESTORE",
        // a renewal sends the stored work specification as a new request (RECEK-74182)
        singleFormatRequired: status === "RESTORE",
        restoreOneOffAsContinuous: status === "RESTORE" && restoreAsContinuous,
        // guarantor contacts are not rendered here, so they cannot be fixed and must not block the save
        validateGuarantorContacts: false,
    });
    var _l = useForm({
        // Czech messages instead of zod's raw "Required" / "Invalid input" (Tools 75665)
        resolver: zodResolver(publisherSchema, {
            errorMap: createZodErrorMap(formatMessage),
        }),
        shouldFocusError: false,
        defaultValues: {
            companyNumber: "",
            name: "",
            nameSuffix: "",
            qualifier: "",
            legalForm: "LEGAL",
            taxNumber: "",
            birthDate: "",
            mainAddress: {
                addressCode: "",
                street: "",
                postalCode: "",
                municipality: "",
                region: { id: "", name: "" },
            },
            mailingAddress: {
                addressCode: "",
                street: "",
                postalCode: "",
                municipality: "",
                region: { id: "", name: "" },
            },
            guarantors: [],
            contacts: [],
            alternativeNames: [],
            internalComment: "",
            version: 0,
            workSpecification: {
                title: "",
                subtitle: "",
                volumeNumber: "",
                partTitle: "",
                authors: [],
                publicationDate: "",
                editionNumber: "",
                coEditionWith: "",
                publicationForm: "",
                publicationType: {
                    printedPublications: [],
                },
                eBookFormats: [],
                otherFormats: [],
                dataCarrierVersions: [],
                audioBookFormats: [],
            },
        },
        mode: "onBlur",
    }), handleSubmit = _l.handleSubmit, register = _l.register, control = _l.control, setValue = _l.setValue, getValues = _l.getValues, trigger = _l.trigger, reset = _l.reset, watch = _l.watch, _m = _l.formState, errors = _m.errors, dirtyFields = _m.dirtyFields, defaultValues = _m.defaultValues, isSubmitted = _m.isSubmitted;
    // the publication form and its refining format are one choice: the component hands over the
    // complete format fields so the payload always carries exactly one format (RECEK-74182)
    var applyWorkSpecFormatFields = function (values) {
        var options = { shouldDirty: true, shouldValidate: isSubmitted };
        setValue("workSpecification.publicationForm", values.publicationForm, options);
        setValue("workSpecification.publicationType.printedPublications", values.publicationType.printedPublications, options);
        setValue("workSpecification.eBookFormats", values.eBookFormats, options);
        setValue("workSpecification.otherFormats", values.otherFormats, options);
        setValue("workSpecification.dataCarrierVersions", values.dataCarrierVersions, options);
        setValue("workSpecification.audioBookFormats", values.audioBookFormats, options);
    };
    var legalFormValue = watch("legalForm");
    var shouldCheckDuplicate = status === "APPROVE" || status === "REJECT" || status === "EDIT";
    var _o = useFieldArray({
        control: control,
        name: "contacts",
    }), contactFields = _o.fields, appendContact = _o.append, removeContactAtIndex = _o.remove;
    var _p = useFieldArray({
        control: control,
        name: "alternativeNames",
    }), alternativeNameFields = _p.fields, appendAlternativeName = _p.append, removeAlternativeNameAtIndex = _p.remove;
    var _q = useFieldArray({
        control: control,
        name: "guarantors",
    }), guarantorFields = _q.fields, appendGuarantor = _q.append, removeGuarantorAtIndex = _q.remove;
    var _r = useState(false), confirmOpen = _r[0], setConfirmOpen = _r[1];
    var _s = useState(""), confirmMessage = _s[0], setConfirmMessage = _s[1];
    var _t = useState("required"), confirmMode = _t[0], setConfirmMode = _t[1];
    var pendingSubmitRef = useRef();
    var pendingGuarantorRef = useRef();
    var skipRequiredCheckRef = useRef(false);
    var skipEmailCheckRef = useRef(false);
    var _u = useState({}), lockedGuarantors = _u[0], setLockedGuarantors = _u[1];
    var _v = useState(false), enableMainAddress = _v[0], setEnableMainAddress = _v[1];
    var _w = useState(false), enableMailingAddress = _w[0], setEnableMailingAddress = _w[1];
    var _x = useState(false), showMailingAddress = _x[0], setShowMailingAddress = _x[1];
    var _y = useState(false), expandAll = _y[0], setExpandAll = _y[1];
    var _z = useState({
        general: true,
        address: true,
        contacts: true,
        alternativeNames: true,
        comments: true,
        guarantors: true,
        workSpecification: true,
    }), accordionStatus = _z[0], setAccordionStatus = _z[1];
    var _0 = useState([]), regions = _0[0], setRegions = _0[1];
    var _1 = useState(false), errorModalOpen = _1[0], setErrorModalOpen = _1[1];
    var _2 = useState(false), setConfirmModalOpen = _2[1];
    var _3 = useState(""), errorMessage = _3[0], setErrorMessage = _3[1];
    // main and mailing address typeaheads share one suggestion list (DB-876: min. 3 characters, 300 ms debounce)
    var addressSuggest = useAddressSuggest(ky);
    var _4 = useState(false), workSpecLoaded = _4[0], setWorkSpecLoaded = _4[1];
    var _5 = useState(false), withoutPrefixAssignment = _5[0], setWithoutPrefixAssignment = _5[1];
    var _6 = useDuplicateTable(), selectedDuplicatePublisher = _6.selectedDuplicatePublisher, onClose = _6.onClose, setSelectedDuplicatePublisherId = _6.setSelectedDuplicatePublisherId;
    useEffect(function () {
        if (legalFormValue === "LEGAL") {
            setValue("birthDate", "", { shouldValidate: true });
        }
    }, [legalFormValue, setValue]);
    var computeDisabledGuarantorFlags = function () {
        var args_1 = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args_1[_i] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([], args_1, true), void 0, function (guarantors) {
            if (guarantors === void 0) { guarantors = []; }
            return __generator(this, function (_a) {
                if (!guarantors.length)
                    return [2 /*return*/, []];
                return [2 /*return*/, Promise.all(guarantors.map(function (g) { return __awaiter(void 0, void 0, void 0, function () {
                        var email, res, err_1;
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    email = (_a = g === null || g === void 0 ? void 0 : g.email) === null || _a === void 0 ? void 0 : _a.trim();
                                    if (!email)
                                        return [2 /*return*/, false];
                                    _b.label = 1;
                                case 1:
                                    _b.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, fetchMultiGuarantorByEmail(ky, email)];
                                case 2:
                                    res = _b.sent();
                                    return [2 /*return*/, res === null || res === void 0 ? void 0 : res.isMultiGuarantor];
                                case 3:
                                    err_1 = _b.sent();
                                    console.error("multi-guarantor check failed:", err_1);
                                    return [2 /*return*/, false];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); }))];
            });
        });
    };
    var publisherData = useQuery(["publisher", id], function () { return fetchPublisherData(id, ky); }, {
        enabled: !!id,
        onSuccess: function (data) { return __awaiter(void 0, void 0, void 0, function () {
            var resetData, flags;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        resetData = __assign(__assign({}, data), { 
                            // a legacy dual role is loaded as PublisherAdmin, so the form shows and saves one role (DB-520)
                            guarantors: (_a = normalizePublisherGuarantors(status === "APPROVE"
                                ? prefillGuarantorRoles(data.guarantors)
                                : data.guarantors)) !== null && _a !== void 0 ? _a : [], birthDate: data.birthDate
                                ? moment(data.birthDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                                : "", 
                            // the backend omits empty values, so stored author / format rows may come back as {}
                            // and must not turn into hidden "Required" errors (Tools 75665)
                            workSpecification: normalizeLoadedWorkSpecification(data.workSpecification) });
                        reset(resetData, {
                            keepDirty: false,
                        });
                        // Capture the full loaded record as the stable approval-check baseline.
                        // This is the SAME object the form is reset to, so it always reflects the
                        // real persisted values — unlike the destructured formState.defaultValues,
                        // which can be stale/empty when the approval check later runs.
                        approvalBaselineRef.current = resetData;
                        setValue("version", data.version);
                        // Trigger re-render of work specification section after data loads
                        setWorkSpecLoaded(false);
                        setTimeout(function () {
                            setWorkSpecLoaded(true);
                        }, 50);
                        if (data.mailingAddress &&
                            (data.mailingAddress.addressCode ||
                                data.mailingAddress.street ||
                                data.mailingAddress.postalCode ||
                                data.mailingAddress.municipality)) {
                            setShowMailingAddress(true);
                        }
                        else {
                            setShowMailingAddress(false);
                        }
                        return [4 /*yield*/, computeDisabledGuarantorFlags(data.guarantors)];
                    case 1:
                        flags = _b.sent();
                        setDisableEmailField(Object.fromEntries(flags.map(function (v, i) { return [i, v]; })));
                        return [2 /*return*/];
                }
            });
        }); },
    }).data;
    useEffect(function () {
        register("version");
    }, [register]);
    // in "Můj nakladatel" a user who is only a plain guarantor may not change the guarantors (edit, add, remove)
    var guarantorsLocked = isPlainGuarantorInMyPublisher(status, activeRoles);
    // the restore form offers restoring a one-off publisher as continuous
    // publishing only when the restore would reactivate its ONE_OFF registration
    var canRestoreAsContinuous = status === "RESTORE" &&
        hasOneOffRegistrationReactivatedByRestore(publisherData);
    // approving without the publisher's own prefix only matters for continuous
    // publishing — a one-off registration always gets a collective-prefix number
    var canApproveWithoutPrefixAssignment = status === "APPROVE" && hasActiveNonOneOffRegistration(publisherData);
    // the restore form must offer the title section even though the ONE_OFF
    // registration is terminated — the restore reactivates it on save
    var showWorkSpecSection = shouldShowWorkSpecSection(publisherData, status, canRestoreAsContinuous && restoreAsContinuous);
    var handleAddressSelection = function (selectedValue, type) { return __awaiter(void 0, void 0, void 0, function () {
        var addressDetails, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fetchAddressCode(ky, selectedValue)];
                case 1:
                    addressDetails = _a.sent();
                    setValue("".concat(type, ".addressCode"), selectedValue);
                    setValue("".concat(type, ".street"), addressDetails.street);
                    setValue("".concat(type, ".postalCode"), addressDetails.postalCode);
                    setValue("".concat(type, ".municipality"), addressDetails.municipality);
                    setValue("".concat(type, ".region"), addressDetails.region || { id: "", name: "" });
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error("Error fetching ".concat(type, " details:"), error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    useQuery("regions", function () { return fetchRegions(ky); }, {
        onSuccess: function (data) {
            setRegions(data);
        },
    });
    var companyNumber = watch("companyNumber");
    var _7 = useState(null), icoError = _7[0], setIcoError = _7[1];
    var _8 = useQuery(["publisher", companyNumber], function () { return lookupPublisherByCompanyNumber(ky, companyNumber !== null && companyNumber !== void 0 ? companyNumber : ""); }, {
        enabled: false,
        retry: false,
        onError: function (error) { return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        // DB-876: a 429 (ARES rate limiter full) says ARES is overloaded, not a generic error
                        _a = setIcoError;
                        return [4 /*yield*/, resolveAresLookupErrorMessage(error, formatMessage, companyNumber)];
                    case 1:
                        // DB-876: a 429 (ARES rate limiter full) says ARES is overloaded, not a generic error
                        _a.apply(void 0, [_b.sent()]);
                        return [2 /*return*/];
                }
            });
        }); },
    }), isIcoFetching = _8.isFetching, refetchIco = _8.refetch;
    var handleIco = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, icoPublisher, isError, error_2;
        var _b, _c, _d, _e, _f, _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    _h.trys.push([0, 4, , 5]);
                    if (!companyNumber || companyNumber.trim() === "") {
                        setIcoError(formatMessage({
                            id: "ui-br-publishers.error.companyNumber.required",
                        }));
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, refetchIco()];
                case 1:
                    _a = _h.sent(), icoPublisher = _a.data, isError = _a.isError;
                    if (isError)
                        return [2 /*return*/];
                    setValue("name", (_b = icoPublisher === null || icoPublisher === void 0 ? void 0 : icoPublisher.name) !== null && _b !== void 0 ? _b : "", { shouldValidate: true });
                    setValue("legalForm", (_c = icoPublisher === null || icoPublisher === void 0 ? void 0 : icoPublisher.legalForm) !== null && _c !== void 0 ? _c : getValues("legalForm"), {
                        shouldValidate: true,
                    });
                    setValue("taxNumber", (_d = icoPublisher === null || icoPublisher === void 0 ? void 0 : icoPublisher.taxNumber) !== null && _d !== void 0 ? _d : getValues("taxNumber"), {
                        shouldValidate: true,
                    });
                    setValue("contacts", (_f = (_e = icoPublisher === null || icoPublisher === void 0 ? void 0 : icoPublisher.contacts) !== null && _e !== void 0 ? _e : getValues("contacts")) !== null && _f !== void 0 ? _f : [], {
                        shouldValidate: true,
                    });
                    if (!((_g = icoPublisher === null || icoPublisher === void 0 ? void 0 : icoPublisher.mainAddress) === null || _g === void 0 ? void 0 : _g.addressCode)) return [3 /*break*/, 3];
                    return [4 /*yield*/, handleAddressSelection(icoPublisher === null || icoPublisher === void 0 ? void 0 : icoPublisher.mainAddress.addressCode, "mainAddress")];
                case 2:
                    _h.sent();
                    _h.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    error_2 = _h.sent();
                    console.error("Error fetching Ares data:", error_2);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var _9 = useFieldArray({
        control: control,
        name: "workSpecification.authors",
    }), authorFields = _9.fields, appendAuthor = _9.append, removeAuthor = _9.remove;
    var watchedAuthors = watch("workSpecification.authors");
    var searchAuthors = useCallback(function (query) { return searchAuthorityAuthors(ky, query); }, [ky]);
    var expandAllSections = function () {
        setAccordionStatus({
            general: true,
            address: true,
            contacts: true,
            alternativeNames: true,
            comments: true,
            guarantors: true,
            workSpecification: true,
        });
        setExpandAll(true);
    };
    var collapseAllSections = function () {
        setAccordionStatus({
            general: false,
            address: false,
            contacts: false,
            alternativeNames: false,
            comments: false,
            guarantors: false,
            workSpecification: false,
        });
        setExpandAll(false);
    };
    var _10 = useFieldArray({
        control: control,
        name: "workSpecification.otherFormats",
    }), otherFormatFields = _10.fields, appendOtherFormat = _10.append, removeOtherFormat = _10.remove;
    var toggleExpandCollapseAll = function () {
        if (expandAll) {
            collapseAllSections();
        }
        else {
            expandAllSections();
        }
    };
    var removePublisherField = function (guarantors) {
        return guarantors.map(function (guarantor) {
            var newGuarantor = __assign({}, guarantor);
            delete newGuarantor.publisher;
            return newGuarantor;
        });
    };
    var getUpdatedStatus = function (action) {
        if (action === "APPROVE" || action === "RESTORE")
            return "ACTIVE";
        if (action === "REJECT")
            return "REJECTED";
        return publisherData === null || publisherData === void 0 ? void 0 : publisherData.status;
    };
    /**
     * Returns to the previous page, or to the parent list when the form was
     * opened by a direct link and has no previous page to go back to.
     */
    var leaveForm = function () {
        if (history.length > 1) {
            history.goBack();
        }
        else {
            history.push(parentPathOfAction(history.location.pathname));
        }
    };
    var navigateAfterUpdate = function (action) {
        if (action === "APPROVE" || action === "REJECT") {
            history.push("/brpublishers/publisher-registrations");
        }
        else {
            leaveForm();
        }
    };
    var handleError = function (error, action) { return __awaiter(void 0, void 0, void 0, function () {
        var responseStatus, _a, errorMessages, msg, _b;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    responseStatus = (_c = error === null || error === void 0 ? void 0 : error.response) === null || _c === void 0 ? void 0 : _c.status;
                    if (responseStatus === 409) {
                        setErrorMessage(formatMessage({
                            id: "ui-br-publishers.publisherEdit.error.message.409",
                        }));
                        setConfirmModalOpen(true);
                        return [2 /*return*/];
                    }
                    // RECEK-76282: the backend refuses another publisher with 403 (a 401 would end the Stripes session)
                    _a = responseStatus === 403;
                    if (!_a) 
                    // RECEK-76282: the backend refuses another publisher with 403 (a 401 would end the Stripes session)
                    return [3 /*break*/, 2];
                    return [4 /*yield*/, hasServerErrorType(error, ErrorType.PUBLISHER_CANNOT_UPDATE_ANOTHER_PUBLISHER)];
                case 1:
                    _a = (_d.sent());
                    _d.label = 2;
                case 2:
                    if (_a) {
                        setErrorMessage(formatMessage({
                            id: "ui-br-publishers.publisherEdit.error.message.foreignPublisher",
                        }));
                        setErrorModalOpen(true);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, isGuarantorsChangeForbiddenError(error)];
                case 3:
                    // DB-876: a plain guarantor may not change the guarantors of their publisher ("Můj nakladatel")
                    if (_d.sent()) {
                        setErrorMessage(formatMessage({
                            id: "ui-br-publishers.publisherEdit.error.message.guarantorsForbidden",
                        }));
                        setErrorModalOpen(true);
                        return [2 /*return*/];
                    }
                    errorMessages = {
                        MY_PUBLISHER: formatMessage({
                            id: "ui-br-publishers.publisherEdit.error.message.edit",
                        }),
                        EDIT: formatMessage({
                            id: "ui-br-publishers.publisherEdit.error.message.edit",
                        }),
                        APPROVE: formatMessage({
                            id: "ui-br-publishers.publisherEdit.error.message.approve",
                        }),
                        REJECT: formatMessage({
                            id: "ui-br-publishers.publisherEdit.error.message.reject",
                        }),
                        RESTORE: formatMessage({
                            id: "ui-br-publishers.publisherEdit.error.message.restore",
                        }),
                    };
                    if (!errorMessages[action]) return [3 /*break*/, 5];
                    return [4 /*yield*/, withServerErrorMessages(errorMessages[action], error)];
                case 4:
                    _b = _d.sent();
                    return [3 /*break*/, 6];
                case 5:
                    _b = formatMessage({
                        id: "ui-br-publishers.errors.generalError",
                    });
                    _d.label = 6;
                case 6:
                    msg = _b;
                    setErrorMessage(msg);
                    setErrorModalOpen(true);
                    return [2 /*return*/];
            }
        });
    }); };
    var getDuplicatesMessage = function () {
        switch (status) {
            case "APPROVE":
                return "ui-br-publishers.publisher.warning.message.duplicatesFound.approve";
            case "EDIT":
                return "ui-br-publishers.publisher.warning.message.duplicatesFound.save";
            default:
                return "ui-br-publishers.publisher.warning.message.duplicatesFound.save";
        }
    };
    var didGuarantorEmailChange = function () {
        var _a;
        var dirtyGuarantors = dirtyArrayItems(dirtyFields.guarantors);
        var formGuarantors = (_a = getValues("guarantors")) !== null && _a !== void 0 ? _a : [];
        return dirtyGuarantors.some(function (g, index) { var _a; return Boolean(g === null || g === void 0 ? void 0 : g.email) && Boolean((_a = formGuarantors[index]) === null || _a === void 0 ? void 0 : _a.id); });
    };
    var openConfirm = function (mode, messageId, data, status) {
        pendingSubmitRef.current = { data: data, status: status };
        setConfirmMode(mode);
        setConfirmMessage(formatMessage({ id: messageId }));
        setConfirmOpen(true);
    };
    var runPreSubmitChecks = function (data, status) {
        var _a;
        if (didGuarantorEmailChange() && !skipEmailCheckRef.current) {
            openConfirm("email", "ui-br-publishers.error.guarantorEmailChanged", data, status);
            return true;
        }
        var canSkipApprovalWarning = hasAtLeastOneRole(activeRoles, [
            RoleEnum.SUPERUSER,
            RoleEnum.AGENCY_WORKER,
        ]);
        // Only a change to one of the fields the backend routes through the update request
        // (PUBLISHER_APPROVAL_FIELDS: the FSD list plus name suffix, qualifier and alternative
        // names) triggers the "wait for approval" dialog. Changes to any other data
        // (contacts, phone, e-mail, mailing address, roles, …) are saved immediately.
        // The check compares the current values against a STABLE baseline captured at
        // load time (approvalBaselineRef) rather than the destructured
        // formState.defaultValues, which can read back stale/empty after a field-array
        // append — that desync made non-empty approved fields look "changed" against an
        // empty baseline and wrongly fired the dialog when only a contact was added.
        // Fallback to defaultValues only when no record was loaded (e.g. no id yet).
        var approvalBaseline = (_a = approvalBaselineRef.current) !== null && _a !== void 0 ? _a : defaultValues;
        if (hasApprovalFieldChanged(data, approvalBaseline) &&
            !skipRequiredCheckRef.current &&
            !canSkipApprovalWarning) {
            openConfirm("required", "ui-br-publishers.error.requiredConfirm", data, status);
            return true;
        }
        return false;
    };
    var submitUpdatedPublisher = function (updatedData, submitStatus) { return __awaiter(void 0, void 0, void 0, function () {
        var error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 5]);
                    return [4 /*yield*/, updatePublisher(ky, id, updatedData)];
                case 1:
                    _a.sent();
                    skipEmailCheckRef.current = false;
                    skipRequiredCheckRef.current = false;
                    setDuplicateWarning("");
                    setDuplicateModalOpen(false);
                    navigateAfterUpdate(submitStatus);
                    return [3 /*break*/, 5];
                case 2:
                    error_3 = _a.sent();
                    console.error("Error updating publisher:", error_3);
                    return [4 /*yield*/, isMultipleWorkSpecFormatsError(error_3)];
                case 3:
                    if (_a.sent()) {
                        setErrorMessage(formatMessage({
                            id: "ui-br-publishers.error.workSpec.multipleFormats",
                        }));
                        setErrorModalOpen(true);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, handleError(error_3, submitStatus)];
                case 4:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var onSubmit = function (data, status) { return __awaiter(void 0, void 0, void 0, function () {
        var workSpecification, rest, initialData, contacts, guarantors, processedGuarantors, updatedData, trimmedReason, publishers, filteredDuplicates, error_4, error_5;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    setIsSubmittingForm(true);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 10, 12, 13]);
                    workSpecification = data.workSpecification, rest = __rest(data, ["workSpecification"]);
                    if (rest.birthDate &&
                        moment(rest.birthDate, "DD/MM/YYYY", true).isValid()) {
                        rest.birthDate = moment(rest.birthDate, "DD/MM/YYYY").format("YYYY-MM-DD");
                    }
                    initialData = __assign(__assign({}, publisherData), rest);
                    contacts = (_a = rest === null || rest === void 0 ? void 0 : rest.contacts) === null || _a === void 0 ? void 0 : _a.filter(function (contact) { return contact.type !== "" || contact.value !== ""; });
                    guarantors = ((_b = normalizePublisherGuarantors(rest === null || rest === void 0 ? void 0 : rest.guarantors)) === null || _b === void 0 ? void 0 : _b.map(function (guarantor) {
                        var _a;
                        return (__assign(__assign({}, guarantor), { contacts: ((_a = guarantor.contacts) === null || _a === void 0 ? void 0 : _a.filter(function (contact) { var _a, _b; return ((_a = contact.type) === null || _a === void 0 ? void 0 : _a.trim()) !== "" && ((_b = contact.value) === null || _b === void 0 ? void 0 : _b.trim()) !== ""; })) || [] }));
                    })) || [];
                    processedGuarantors = removePublisherField(guarantors);
                    updatedData = __assign(__assign({}, initialData), { contacts: contacts, guarantors: processedGuarantors, status: (_c = getUpdatedStatus(status)) !== null && _c !== void 0 ? _c : initialData.status });
                    // Registrations are managed via dedicated endpoints and ignored on PUT
                    delete updatedData.registrations;
                    // The (optional) rejection reason is only relevant when the registration is
                    // being rejected; the BE persists it and passes it into the notification email.
                    if (status === "REJECT") {
                        trimmedReason = rejectionReason.trim();
                        updatedData.rejectionReason = trimmedReason || undefined;
                    }
                    // the one-off title data must reach the backend, otherwise the agency
                    // cannot create the title (a missing work specification keeps the stored one)
                    if (isWorkSpecEditable && showWorkSpecSection && workSpecification) {
                        updatedData.workSpecification =
                            normalizeWorkSpecification(workSpecification);
                    }
                    else {
                        delete updatedData.workSpecification;
                    }
                    if (canApproveWithoutPrefixAssignment && withoutPrefixAssignment) {
                        updatedData.withoutPrefixAssignment = true;
                    }
                    else {
                        delete updatedData.withoutPrefixAssignment;
                    }
                    // the BE keeps the ONE_OFF registration terminated, creates a CONTINUOUS
                    // one and clears the stored work specification
                    if (status === "RESTORE" &&
                        canRestoreAsContinuous &&
                        restoreAsContinuous) {
                        updatedData.restoreAsContinuous = true;
                        delete updatedData.workSpecification;
                    }
                    if (runPreSubmitChecks(data, status))
                        return [2 /*return*/];
                    if (!(Object.keys(dirtyFields).length === 0)) return [3 /*break*/, 3];
                    return [4 /*yield*/, submitUpdatedPublisher(updatedData, status)];
                case 2:
                    _d.sent();
                    return [2 /*return*/];
                case 3:
                    if (!shouldCheckDuplicate) return [3 /*break*/, 8];
                    _d.label = 4;
                case 4:
                    _d.trys.push([4, 6, , 8]);
                    return [4 /*yield*/, getDuplicities(ky, updatedData)];
                case 5:
                    publishers = (_d.sent()).publishers;
                    if (publishers && publishers.length > 0) {
                        filteredDuplicates = publishers.filter(function (pub) { return pub.id !== id; });
                        if (filteredDuplicates.length > 0) {
                            setPotentialDuplicates(filteredDuplicates);
                            setDuplicateWarning(formatMessage({
                                id: getDuplicatesMessage(),
                            }));
                            duplicateSubmitRef.current = { data: updatedData, status: status };
                            setDuplicateModalOpen(true);
                            return [2 /*return*/];
                        }
                    }
                    return [3 /*break*/, 8];
                case 6:
                    error_4 = _d.sent();
                    return [4 /*yield*/, handleError(error_4, status)];
                case 7:
                    _d.sent();
                    console.error("Error updating publisher:", error_4);
                    return [2 /*return*/];
                case 8: return [4 /*yield*/, submitUpdatedPublisher(updatedData, status)];
                case 9:
                    _d.sent();
                    return [3 /*break*/, 13];
                case 10:
                    error_5 = _d.sent();
                    console.error("Error submitting publisher:", error_5);
                    return [4 /*yield*/, handleError(error_5, status)];
                case 11:
                    _d.sent();
                    return [3 /*break*/, 13];
                case 12:
                    setIsSubmittingForm(false);
                    return [7 /*endfinally*/];
                case 13: return [2 /*return*/];
            }
        });
    }); };
    // Duplicate warning confirmed ("Přesto pokračovat") → finish the submit
    // directly instead of relying on a fragile isEqual + repeated-click path.
    var handleDuplicateConfirm = function () { return __awaiter(void 0, void 0, void 0, function () {
        var pending;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    pending = duplicateSubmitRef.current;
                    duplicateSubmitRef.current = undefined;
                    setDuplicateModalOpen(false);
                    if (!pending)
                        return [2 /*return*/];
                    setIsSubmittingForm(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, submitUpdatedPublisher(pending.data, pending.status)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    setIsSubmittingForm(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleDuplicateCancel = function () {
        duplicateSubmitRef.current = undefined;
        setDuplicateModalOpen(false);
    };
    var sectionForFieldPath = function (path) {
        var top = path.split(".")[0];
        switch (top) {
            case "registrations":
            case "companyNumber":
            case "name":
            case "nameSuffix":
            case "qualifier":
            case "legalForm":
            case "taxNumber":
            case "birthDate":
            case "status":
                return "general";
            case "mainAddress":
            case "mailingAddress":
                return "address";
            case "contacts":
                return "contacts";
            case "alternativeNames":
                return "alternativeNames";
            case "internalComment":
                return "comments";
            case "guarantors":
                return "guarantors";
            case "workSpecification":
                return "workSpecification";
            default:
                return null;
        }
    };
    /**
     * Makes an invalid address field fixable: shows the mailing address and turns
     * address editing on, keeping the loaded values (unlike the checkboxes, which
     * clear the address when editing is turned on).
     */
    var unlockAddressForField = function (path) {
        var _a = path.split("."), address = _a[0], field = _a[1];
        if (field === "addressCode")
            return;
        if (address === "mainAddress") {
            setEnableMainAddress(true);
        }
        else if (address === "mailingAddress") {
            setShowMailingAddress(true);
            setEnableMailingAddress(true);
        }
    };
    // Expand the accordion that holds the offending field so scrollToError can
    // reach it (fields inside a collapsed section are otherwise unreachable).
    var openSectionForField = function (path) {
        var section = sectionForFieldPath(path);
        if (section) {
            setAccordionStatus(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a[section] = true, _a)));
            });
        }
        unlockAddressForField(path);
    };
    // Last-resort visible feedback when no invalid input can be focused, so the
    // submit never fails silently.
    var showValidationSummary = function (invalidFields) {
        // every entry names its section and field in Czech (Tools 75665)
        var fields = describeInvalidFields(invalidFields, formatMessage, getValues()).join(" • ");
        setErrorMessage(formatMessage({ id: "ui-br-publishers.validation.summary.message" }, { fields: fields }));
        setErrorModalOpen(true);
    };
    var handleWarningConfirm = useCallback(function () {
        var _a, _b;
        setConfirmOpen(false);
        switch (confirmMode) {
            case "guarantor": {
                var _c = pendingGuarantorRef.current, index_1 = _c.index, guarantor = _c.guarantor;
                setValue("guarantors.".concat(index_1, ".firstName"), guarantor.firstName);
                setValue("guarantors.".concat(index_1, ".lastName"), guarantor.lastName);
                setValue("guarantors.".concat(index_1, ".titlesBefore"), (_a = guarantor.titlesBefore) !== null && _a !== void 0 ? _a : "");
                setValue("guarantors.".concat(index_1, ".titlesAfter"), (_b = guarantor.titlesAfter) !== null && _b !== void 0 ? _b : "");
                setLockedGuarantors(function (m) {
                    var _a;
                    return (__assign(__assign({}, m), (_a = {}, _a[index_1] = true, _a)));
                });
                pendingGuarantorRef.current = undefined;
                break;
            }
            case "reload":
                window.location.reload();
                break;
            case "email":
                skipEmailCheckRef.current = true;
                skipRequiredCheckRef.current = true;
                break;
            case "required":
                skipRequiredCheckRef.current = true;
                break;
            default:
                break;
        }
        if (pendingSubmitRef.current &&
            confirmMode !== "reload" &&
            confirmMode !== "guarantor") {
            var _d = pendingSubmitRef.current, data = _d.data, status_1 = _d.status;
            pendingSubmitRef.current = undefined;
            onSubmit(data, status_1);
        }
    }, [confirmMode, onSubmit, setValue, setLockedGuarantors]);
    var handleWarningCancel = useCallback(function () {
        setConfirmOpen(false);
        if (pendingGuarantorRef.current) {
            var index = pendingGuarantorRef.current.index;
            setValue("guarantors.".concat(index, ".email"), "");
            pendingGuarantorRef.current = undefined;
        }
    }, [setValue]);
    var handleGuarantorEmailBlur = function (index) { return __awaiter(void 0, void 0, void 0, function () {
        var email, guarantor, error_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    email = getValues("guarantors.".concat(index, ".email"));
                    if (!email)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fetchGuarantorByEmail(ky, email)];
                case 2:
                    guarantor = _a.sent();
                    pendingGuarantorRef.current = { index: index, guarantor: guarantor };
                    setConfirmMode("guarantor");
                    setConfirmMessage(formatMessage({ id: "ui-br-publishers.error.guarantorDuplicity" }, {
                        firstName: guarantor.firstName,
                        lastName: guarantor.lastName,
                    }));
                    setConfirmOpen(true);
                    return [3 /*break*/, 4];
                case 3:
                    error_6 = _a.sent();
                    console.error("Failed to fetch guarantor by email (\u201C".concat(email, "\u201D):"), error_6);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var unlockGuarantor = useCallback(function (index) {
        setLockedGuarantors(function (prev) {
            var rest = __assign({}, prev);
            delete rest[index];
            return rest;
        });
    }, []);
    var getPaneTitle = function (status) {
        switch (status) {
            case "EDIT":
                return formatMessage({
                    id: "ui-br-publishers.publishers.edit.pane.title",
                });
            case "APPROVE":
                return formatMessage({
                    id: "ui-br-publishers.publishers.edit.pane.title.approve",
                });
            case "RESTORE":
                return formatMessage({
                    id: "ui-br-publishers.publishers.edit.pane.title.restore",
                });
            default:
                return "";
        }
    };
    var getButtonText = function (status) {
        switch (status) {
            case "APPROVE":
                return formatMessage({
                    id: "ui-br-publishers.publishers.edit.button.approve",
                });
            case "REJECT":
                return formatMessage({
                    id: "ui-br-publishers.publishers.edit.button.reject",
                });
            case "RESTORE":
                return formatMessage({
                    id: "ui-br-publishers.publishers.edit.button.restore",
                });
            default:
                return formatMessage({
                    id: "ui-br-publishers.button.save",
                });
        }
    };
    var handleStatusSubmit = function (e) {
        e.preventDefault();
        var canSeeGuarantors = hasAtLeastOneRole(activeRoles, [
            RoleEnum.PUBLISHER_ADMIN,
            RoleEnum.AGENCY_WORKER,
        ]);
        handleSubmit(function (data) { return onSubmit(data, status); }, function (validationErrors) {
            var hasOnlyGuarantorErrors = validationErrors.guarantors &&
                Object.keys(validationErrors).length === 1;
            if (hasOnlyGuarantorErrors && !canSeeGuarantors) {
                setErrorMessage(formatMessage({
                    id: "ui-br-publishers.error.contactAdminForGuarantorData",
                }));
                setErrorModalOpen(true);
                return;
            }
            scrollToError(validationErrors, {
                openSectionForField: openSectionForField,
                onUnresolvedErrors: showValidationSummary,
            });
        })(e);
    };
    useEffect(function () {
        if (legalFormValue !== "NATURAL" ||
            (companyNumber && companyNumber.trim() !== "")) {
            setValue("mainAddressPublishConsent", false);
            setValue("mailingAddressPublishConsent", false);
        }
    }, [legalFormValue, companyNumber, setValue]);
    useEffect(function () {
        if (shouldCheckDuplicate && publisherData) {
            getDuplicities(ky, publisherData)
                .then(function (_a) {
                var publishers = _a.publishers;
                if (publishers && publishers.length > 0) {
                    setPotentialDuplicates(publishers.filter(function (pub) { return pub.id !== id; }));
                }
                else {
                    setPotentialDuplicates([]);
                }
            })
                .catch(function (error) {
                return console.error("Error fetching duplicates on load:", error);
            });
        }
    }, [publisherData]);
    var topRef = useScrollOnPotentialDuplicates(potentialDuplicates).topRef;
    useEffect(function () {
        if (Object.keys(errors).length > 0) {
            scrollToError(errors, { openSectionForField: openSectionForField });
        }
    }, [errors]);
    function handleValidationErrors(validationErrors) {
        scrollToError(validationErrors, {
            openSectionForField: openSectionForField,
            onUnresolvedErrors: showValidationSummary,
        });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(RecekPaneSet, null,
            React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: getPaneTitle(status), footer: React.createElement(PaneFooter, { renderStart: status === "APPROVE" ? (React.createElement(React.Fragment, null,
                        canApproveWithoutPrefixAssignment && (React.createElement(Checkbox, { label: formatMessage({
                                id: "ui-br-publishers.publishers.edit.checkbox.withoutPrefixAssignment",
                            }), checked: withoutPrefixAssignment, onChange: function (e) {
                                return setWithoutPrefixAssignment(e.target.checked);
                            } })),
                        React.createElement(Button, { buttonStyle: "primary", type: "button", disabled: isSubmittingForm, onClick: function () {
                                return handleSubmit(function (data) { return onSubmit(data, "APPROVE"); }, handleValidationErrors)();
                            } }, isSubmittingForm ? (React.createElement(Spinner, null)) : (getButtonText("APPROVE"))),
                        React.createElement(Button, { buttonStyle: "danger", type: "button", disabled: isSubmittingForm, onClick: function () {
                                setRejectionReason("");
                                setRejectModalOpen(true);
                            } }, isSubmittingForm ? React.createElement(Spinner, null) : getButtonText("REJECT")))) : (React.createElement(React.Fragment, null,
                        canRestoreAsContinuous && (React.createElement(Checkbox, { label: formatMessage({
                                id: "ui-br-publishers.publishers.edit.checkbox.restoreAsContinuous",
                            }), checked: restoreAsContinuous, onChange: function (e) {
                                return setRestoreAsContinuous(e.target.checked);
                            } })),
                        React.createElement(Button, { buttonStyle: "primary", type: "button", disabled: isSubmittingForm, onClick: handleStatusSubmit }, isSubmittingForm ? React.createElement(Spinner, null) : getButtonText(status)))), renderEnd: React.createElement(Button, { buttonStyle: "default", onClick: leaveForm }, formatMessage({ id: "ui-br-publishers.button.cancel" })) }) },
                React.createElement(ErrorModal, { open: errorModalOpen, label: formatMessage({
                        id: "ui-br-publishers.error.modal.title",
                    }), content: errorMessage, onClose: function () { return setErrorModalOpen(false); } }),
                React.createElement(WarningModal, { open: confirmOpen, mode: confirmMode === "reload" ? "reload" : "continue", message: confirmMessage, onConfirm: handleWarningConfirm, onCancel: handleWarningCancel }),
                React.createElement(WarningModal, { open: duplicateModalOpen, mode: "continue", message: duplicateWarning, confirmLabel: formatMessage({
                        id: "ui-br-publishers.button.continueAnyway",
                    }), onConfirm: handleDuplicateConfirm, onCancel: handleDuplicateCancel }),
                React.createElement(Modal, { open: rejectModalOpen, label: formatMessage({
                        id: "ui-br-publishers.publishers.reject.accordion.label",
                    }), onClose: function () { return setRejectModalOpen(false); }, size: "small", dismissible: true, footer: React.createElement(ModalFooter, null,
                        React.createElement(Button, { buttonStyle: "danger", disabled: isSubmittingForm, onClick: function () {
                                setRejectModalOpen(false);
                                onSubmit(getValues(), "REJECT");
                            } }, isSubmittingForm ? React.createElement(Spinner, null) : getButtonText("REJECT")),
                        React.createElement(Button, { onClick: function () { return setRejectModalOpen(false); } },
                            React.createElement(FormattedMessage, { id: "ui-br-publishers.button.cancel" }))) },
                    React.createElement(RecekTextArea, { labelId: "ui-br-publishers.publishers.reject.textArea.label.rejectionReason", autoComplete: "off", value: rejectionReason, onChange: function (e) {
                            return setRejectionReason(e.target.value);
                        } })),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12, style: { display: "flex", justifyContent: "flex-end" } },
                        React.createElement(Button, { onClick: toggleExpandCollapseAll, buttonStyle: "default" }, expandAll ? (React.createElement(FormattedMessage, { id: "ui-br-publishers.button.collapse.all" })) : (React.createElement(FormattedMessage, { id: "ui-br-publishers.button.expand.all" }))))),
                React.createElement("form", { onSubmit: function (e) { return e.preventDefault(); } },
                    React.createElement(AccordionSet, null,
                        React.createElement("div", { ref: topRef }),
                        (publisherData === null || publisherData === void 0 ? void 0 : publisherData.status) === "REJECTED" &&
                            (publisherData === null || publisherData === void 0 ? void 0 : publisherData.rejectionReason) ? (React.createElement(Accordion, { label: formatMessage({
                                id: "ui-br-publishers.publishers.reject.accordion.label",
                            }) },
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 12 },
                                    React.createElement(RenderField, { label: formatMessage({
                                            id: "ui-br-publishers.publishers.detail.label.rejectionReason",
                                        }), value: publisherData.rejectionReason }))))) : null,
                        (potentialDuplicates === null || potentialDuplicates === void 0 ? void 0 : potentialDuplicates.length) > 0 ? (React.createElement(Accordion, { id: "duplicates-table", label: formatMessage({
                                id: "ui-br-publishers.publishers.accordion.label.potentialDuplicates",
                            }) },
                            duplicateWarning && (React.createElement("div", { style: { color: "red", marginBottom: "1rem" } }, duplicateWarning)),
                            React.createElement(DuplicateTable, { duplicates: potentialDuplicates, onDuplicateClick: setSelectedDuplicatePublisherId }))) : null,
                        React.createElement(Accordion, { label: formatMessage({
                                id: "ui-br-publishers.publishers.accordion.label.general",
                            }), open: accordionStatus.general, onToggle: function () {
                                return setAccordionStatus(__assign(__assign({}, accordionStatus), { general: !accordionStatus.general }));
                            } },
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 12 },
                                    React.createElement(RenderField, { label: formatMessage({
                                            id: "ui-br-publishers.publishers.label.registrations",
                                        }), value: formatRegistrationsSummary(formatMessage, getActiveRegistrations(publisherData)) }))),
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 6, style: {
                                        display: "flex",
                                        alignItems: Boolean((_b = errors.companyNumber) === null || _b === void 0 ? void 0 : _b.message) || icoError
                                            ? "center"
                                            : "flex-end",
                                    } },
                                    React.createElement(Controller, { control: control, name: "companyNumber", render: function (_a) {
                                            var _b, _c;
                                            var field = _a.field;
                                            return (React.createElement(React.Fragment, null,
                                                React.createElement(RecekTextField, __assign({ labelId: "ui-br-publishers.publishers.general.field.label.companyNumber", required: true }, field, { autoComplete: "off", onBlur: function () {
                                                        field.onBlur();
                                                        trigger([
                                                            "companyNumber",
                                                            "taxNumber",
                                                            "birthDate",
                                                        ]);
                                                    }, error: (_c = (_b = errors.companyNumber) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : icoError, onChange: function (e) {
                                                        field.onChange(e);
                                                        setIcoError(null);
                                                    } })),
                                                React.createElement(Button, { buttonStyle: "primary", onClick: handleIco, disabled: isIcoFetching, style: {
                                                        marginLeft: "16px",
                                                        marginBottom: "1rem",
                                                    } }, isIcoFetching ? (React.createElement(Spinner, null)) : (React.createElement(FormattedMessage, { id: "ui-br-publishers.publishers.general.button.companyNumber" })))));
                                        } }))),
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 6 },
                                    React.createElement(Controller, { control: control, name: "legalForm", render: function (_a) {
                                            var field = _a.field;
                                            return (React.createElement(RecekSelect, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.general.select.label.legalForm", onChange: function (e) {
                                                    field.onChange(e);
                                                    trigger([
                                                        "companyNumber",
                                                        "taxNumber",
                                                        "birthDate",
                                                    ]);
                                                } }),
                                                React.createElement("option", { value: "UNKNOWN" }, formatMessage({
                                                    id: "ui-br-publishers.publishers.general.select.legal.form.unknown",
                                                })),
                                                React.createElement("option", { value: "LEGAL" }, formatMessage({
                                                    id: "ui-br-publishers.publishers.general.select.label.legal",
                                                })),
                                                React.createElement("option", { value: "NATURAL" }, formatMessage({
                                                    id: "ui-br-publishers.publishers.general.select.label.natural",
                                                }))));
                                        } }))),
                            (status === "APPROVE" ||
                                status === "REJECT" ||
                                status === "EDIT" ||
                                status === "RESTORE") &&
                                watch("companyNumber") && (React.createElement(Col, { xs: 6 },
                                React.createElement("div", { style: { marginBottom: "8px" } },
                                    React.createElement("a", { href: "https://ares.gov.cz/ekonomicke-subjekty?ico=".concat(watch("companyNumber")), target: "_blank", rel: "noopener noreferrer" },
                                        React.createElement(FormattedMessage, { id: "ui-br-publishers.publishers.general.link.label.companyNumber" }))))),
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 6 },
                                    React.createElement(Controller, { control: control, name: "name", render: function (_a) {
                                            var _b;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({ labelId: legalFormValue === "LEGAL"
                                                    ? "ui-br-publishers.publishers.general.field.label.name.legal"
                                                    : "ui-br-publishers.publishers.general.field.label.name.natural" }, field, { autoComplete: "off", required: true, error: (_b = errors.name) === null || _b === void 0 ? void 0 : _b.message })));
                                        } })),
                                React.createElement(Col, { xs: 6 },
                                    React.createElement(Controller, { control: control, name: "nameSuffix", render: function (_a) {
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({ labelId: "ui-br-publishers.publishers.general.field.label.nameSuffix" }, field, { autoComplete: "off" })));
                                        } }))),
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 6 },
                                    React.createElement(Controller, { control: control, name: "taxNumber", render: function (_a) {
                                            var _b;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({ labelId: "ui-br-publishers.publishers.general.field.label.taxNumber" }, field, { autoComplete: "off", required: true, onBlur: function () {
                                                    field.onBlur();
                                                    trigger([
                                                        "companyNumber",
                                                        "taxNumber",
                                                        "birthDate",
                                                    ]);
                                                }, error: (_b = errors.taxNumber) === null || _b === void 0 ? void 0 : _b.message })));
                                        } })),
                                React.createElement(Col, { xs: 6 },
                                    React.createElement(Controller, { control: control, name: "qualifier", render: function (_a) {
                                            var _b;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({ labelId: "ui-br-publishers.publishers.general.field.label.qualifier" }, field, { autoComplete: "off", error: (_b = errors.qualifier) === null || _b === void 0 ? void 0 : _b.message })));
                                        } }))),
                            legalFormValue === "NATURAL" && (React.createElement(Row, null,
                                React.createElement(Col, { xs: 6 },
                                    React.createElement(Controller, { control: control, name: "birthDate", render: function (_a) {
                                            var _b;
                                            var field = _a.field;
                                            return (React.createElement(RecekDatepicker, __assign({ labelId: "ui-br-publishers.publishers.general.datePicker.label.birthDate" }, field, { autoComplete: "off", onBlur: function () {
                                                    field.onBlur();
                                                    trigger([
                                                        "companyNumber",
                                                        "taxNumber",
                                                        "birthDate",
                                                    ]);
                                                }, error: (_b = errors.birthDate) === null || _b === void 0 ? void 0 : _b.message, exclude: function (day) {
                                                    return day.isAfter(moment());
                                                }, backendDateStandard: "YYYY-MM-DD", dateFormat: "DD/MM/YYYY", placeholder: "DD/MM/RRRR" })));
                                        } }))))),
                        React.createElement(Accordion, { label: formatMessage({
                                id: "ui-br-publishers.publishers.accordion.label.address",
                            }), open: accordionStatus.address, onToggle: function () {
                                return setAccordionStatus(__assign(__assign({}, accordionStatus), { address: !accordionStatus.address }));
                            } },
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 6 },
                                    React.createElement(Controller, { control: control, name: "mainAddress.addressCode", render: function (_a) {
                                            var field = _a.field;
                                            return (React.createElement(RecekSelection, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.mainAddress.selection.label.addressCode", asyncFilter: true, onFilter: addressSuggest.onFilter, loading: addressSuggest.loading, loadingMessage: React.createElement(FormattedMessage, { id: "ui-br-publishers.address.suggest.loading" }), emptyMessage: React.createElement(FormattedMessage, { id: addressSuggest.emptyMessageId }), dataOptions: addressSuggest.addresses.map(function (address) { return ({
                                                    value: address.addressCode,
                                                    label: address.address,
                                                }); }), onChange: function (selectedValue) {
                                                    field.onChange(selectedValue);
                                                    handleAddressSelection(selectedValue, "mainAddress");
                                                } })));
                                        } })),
                                React.createElement(Col, { xs: 6 },
                                    legalFormValue === "NATURAL" &&
                                        (!companyNumber || companyNumber.trim() === "") && (React.createElement(Controller, { control: control, name: "mainAddressPublishConsent", render: function (_a) {
                                            var _b = _a.field, onChange = _b.onChange, onBlur = _b.onBlur, value = _b.value, ref = _b.ref, name = _b.name;
                                            return (React.createElement(Checkbox, { label: formatMessage({
                                                    id: "ui-br-publishers.publishers.mainAddress.checkbox.label.addressPublishConsent",
                                                }), checked: value, onChange: function (e) { return onChange(e.target.checked); }, onBlur: onBlur, inputRef: ref, name: name }));
                                        } })),
                                    React.createElement(Checkbox, { label: formatMessage({
                                            id: "ui-br-publishers.publishers.mainAddress.checkbox.label.address",
                                        }), checked: enableMainAddress, onChange: function () {
                                            setEnableMainAddress(!enableMainAddress);
                                            if (!enableMainAddress) {
                                                setValue("mainAddress.addressCode", "");
                                                setValue("mainAddress.street", "");
                                                setValue("mainAddress.postalCode", "");
                                                setValue("mainAddress.municipality", "");
                                                setValue("mainAddress.region", { id: "", name: "" });
                                            }
                                        } })),
                                React.createElement(Col, { xs: 6 },
                                    React.createElement(Controller, { control: control, name: "mainAddress.region.id", render: function (_a) {
                                            var _b, _c, _d, _e, _f, _g;
                                            var field = _a.field;
                                            return (React.createElement(RecekSelect, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.mainAddress.select.label.region", required: true, error: (_e = (_d = (_c = (_b = errors.mainAddress) === null || _b === void 0 ? void 0 : _b.region) === null || _c === void 0 ? void 0 : _c.id) === null || _d === void 0 ? void 0 : _d.message) !== null && _e !== void 0 ? _e : (_g = (_f = errors.mainAddress) === null || _f === void 0 ? void 0 : _f.region) === null || _g === void 0 ? void 0 : _g.message, disabled: !enableMainAddress, dataOptions: __spreadArray([
                                                    {
                                                        value: "",
                                                        label: formatMessage({
                                                            id: "ui-br-publishers.publishers.mainAddress.select.label.default",
                                                        }),
                                                    }
                                                ], regions.map(function (region) { return ({
                                                    value: region.id,
                                                    label: region.name,
                                                }); }), true), onChange: function (e) {
                                                    var selectedRegion = regions.find(function (region) { return region.id === e.target.value; });
                                                    setValue("mainAddress.region", selectedRegion || { id: "", name: "" });
                                                } })));
                                        } })),
                                React.createElement(Col, { xs: 6 },
                                    React.createElement(Controller, { control: control, name: "mainAddress.street", render: function (_a) {
                                            var _b, _c;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.mainAddress.field.label.street", error: (_c = (_b = errors.mainAddress) === null || _b === void 0 ? void 0 : _b.street) === null || _c === void 0 ? void 0 : _c.message, disabled: !enableMainAddress })));
                                        } })),
                                React.createElement(Col, { xs: 6 },
                                    React.createElement(Controller, { control: control, name: "mainAddress.postalCode", render: function (_a) {
                                            var _b, _c;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.general.field.label.postalCode", error: (_c = (_b = errors.mainAddress) === null || _b === void 0 ? void 0 : _b.postalCode) === null || _c === void 0 ? void 0 : _c.message, disabled: !enableMainAddress })));
                                        } })),
                                React.createElement(Col, { xs: 6 },
                                    React.createElement(Controller, { control: control, name: "mainAddress.municipality", render: function (_a) {
                                            var _b, _c;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.general.field.label.municipality", error: (_c = (_b = errors.mainAddress) === null || _b === void 0 ? void 0 : _b.municipality) === null || _c === void 0 ? void 0 : _c.message, disabled: !enableMainAddress })));
                                        } }))),
                            React.createElement(Col, { xs: 6 },
                                React.createElement(Checkbox, { label: formatMessage({
                                        id: "ui-br-publishers.publishers.mailingAddress.checkbox.label.show",
                                    }), checked: showMailingAddress, onChange: function () {
                                        setShowMailingAddress(!showMailingAddress);
                                        if (showMailingAddress) {
                                            setValue("mailingAddress.addressCode", "");
                                            setValue("mailingAddress.street", "");
                                            setValue("mailingAddress.postalCode", "");
                                            setValue("mailingAddress.municipality", "");
                                            setValue("mailingAddress.region", { id: "", name: "" });
                                            setValue("mailingAddressPublishConsent", false);
                                            setEnableMailingAddress(false);
                                        }
                                    } })),
                            showMailingAddress && (React.createElement(React.Fragment, null,
                                React.createElement(Row, null,
                                    React.createElement(Col, { xs: 6 },
                                        React.createElement(Controller, { control: control, name: "mailingAddress.addressCode", render: function (_a) {
                                                var field = _a.field;
                                                return (React.createElement(RecekSelection, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.mailingAddress.selection.label.addressCode", asyncFilter: true, onFilter: addressSuggest.onFilter, loading: addressSuggest.loading, loadingMessage: React.createElement(FormattedMessage, { id: "ui-br-publishers.address.suggest.loading" }), emptyMessage: React.createElement(FormattedMessage, { id: addressSuggest.emptyMessageId }), dataOptions: addressSuggest.addresses.map(function (address) { return ({
                                                        value: address.addressCode,
                                                        label: address.address,
                                                    }); }), onChange: function (selectedValue) {
                                                        field.onChange(selectedValue);
                                                        handleAddressSelection(selectedValue, "mailingAddress");
                                                    } })));
                                            } })),
                                    React.createElement(Col, { xs: 6 },
                                        legalFormValue === "NATURAL" &&
                                            (!companyNumber || companyNumber.trim() === "") && (React.createElement(Controller, { control: control, name: "mailingAddressPublishConsent", render: function (_a) {
                                                var _b = _a.field, onChange = _b.onChange, onBlur = _b.onBlur, value = _b.value, ref = _b.ref, name = _b.name;
                                                return (React.createElement(Checkbox, { label: formatMessage({
                                                        id: "ui-br-publishers.publishers.mainAddress.checkbox.label.addressPublishConsent",
                                                    }), checked: value, onChange: function (e) { return onChange(e.target.checked); }, onBlur: onBlur, inputRef: ref, name: name }));
                                            } })),
                                        React.createElement(Checkbox, { label: formatMessage({
                                                id: "ui-br-publishers.publishers.mailingAddress.checkbox.label.address",
                                            }), checked: enableMailingAddress, onChange: function () {
                                                setEnableMailingAddress(!enableMailingAddress);
                                                if (!enableMailingAddress) {
                                                    setValue("mailingAddress.addressCode", "");
                                                    setValue("mailingAddress.street", "");
                                                    setValue("mailingAddress.postalCode", "");
                                                    setValue("mailingAddress.municipality", "");
                                                    setValue("mailingAddress.region", {
                                                        id: "",
                                                        name: "",
                                                    });
                                                }
                                            } })),
                                    React.createElement(Col, { xs: 6 },
                                        React.createElement(Controller, { control: control, name: "mailingAddress.region.id", render: function (_a) {
                                                var _b, _c, _d, _e, _f, _g;
                                                var field = _a.field;
                                                return (React.createElement(RecekSelect, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.mailingAddress.select.label.region", error: (_e = (_d = (_c = (_b = errors.mailingAddress) === null || _b === void 0 ? void 0 : _b.region) === null || _c === void 0 ? void 0 : _c.id) === null || _d === void 0 ? void 0 : _d.message) !== null && _e !== void 0 ? _e : (_g = (_f = errors.mailingAddress) === null || _f === void 0 ? void 0 : _f.region) === null || _g === void 0 ? void 0 : _g.message, disabled: !enableMailingAddress, dataOptions: __spreadArray([
                                                        { value: "", label: "--- Vyberte kraj ---" }
                                                    ], regions.map(function (region) { return ({
                                                        value: region.id,
                                                        label: region.name,
                                                    }); }), true), onChange: function (e) {
                                                        var selectedRegion = regions.find(function (region) { return region.id === e.target.value; });
                                                        setValue("mailingAddress.region", selectedRegion || { id: "", name: "" });
                                                    } })));
                                            } })),
                                    React.createElement(Col, { xs: 6 },
                                        React.createElement(Controller, { control: control, name: "mailingAddress.street", render: function (_a) {
                                                var _b, _c;
                                                var field = _a.field;
                                                return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.mailingAddress.field.label.street", error: (_c = (_b = errors.mailingAddress) === null || _b === void 0 ? void 0 : _b.street) === null || _c === void 0 ? void 0 : _c.message, disabled: !enableMailingAddress })));
                                            } })),
                                    React.createElement(Col, { xs: 6 },
                                        React.createElement(Controller, { control: control, name: "mailingAddress.postalCode", render: function (_a) {
                                                var _b, _c;
                                                var field = _a.field;
                                                return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.general.field.label.postalCode", error: (_c = (_b = errors.mailingAddress) === null || _b === void 0 ? void 0 : _b.postalCode) === null || _c === void 0 ? void 0 : _c.message, disabled: !enableMailingAddress })));
                                            } })),
                                    React.createElement(Col, { xs: 6 },
                                        React.createElement(Controller, { control: control, name: "mailingAddress.municipality", render: function (_a) {
                                                var _b, _c;
                                                var field = _a.field;
                                                return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.general.field.label.municipality", error: (_c = (_b = errors.mailingAddress) === null || _b === void 0 ? void 0 : _b.municipality) === null || _c === void 0 ? void 0 : _c.message, disabled: !enableMailingAddress })));
                                            } })))))),
                        React.createElement(Accordion, { label: formatMessage({
                                id: "ui-br-publishers.publishers.accordion.label.contacts",
                            }), open: accordionStatus.contacts, onToggle: function () {
                                return setAccordionStatus(__assign(__assign({}, accordionStatus), { contacts: !accordionStatus.contacts }));
                            } },
                            contactFields.map(function (field, index) { return (React.createElement(Row, { key: field.id },
                                React.createElement(Col, { xs: 4 },
                                    React.createElement(Controller, { control: control, name: "contacts.".concat(index, ".type"), render: function (_a) {
                                            var _b, _c, _d, _e, _f;
                                            var field = _a.field;
                                            return (React.createElement(RecekSelect, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.contacts.select.label.type", error: typeof ((_c = (_b = errors.contacts) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.type) === "object"
                                                    ? (_f = (_e = (_d = errors.contacts) === null || _d === void 0 ? void 0 : _d[index]) === null || _e === void 0 ? void 0 : _e.type) === null || _f === void 0 ? void 0 : _f.message
                                                    : undefined, dataOptions: [
                                                    {
                                                        value: "",
                                                        label: formatMessage({
                                                            id: "ui-br-publishers.publishers.contacts.select.label.default",
                                                        }),
                                                    },
                                                    {
                                                        value: "EMAIL",
                                                        label: formatMessage({
                                                            id: "ui-br-publishers.publishers.contacts.select.label.email",
                                                        }),
                                                    },
                                                    {
                                                        value: "WEB",
                                                        label: formatMessage({
                                                            id: "ui-br-publishers.publishers.contacts.select.label.web",
                                                        }),
                                                    },
                                                    {
                                                        value: "PHONE",
                                                        label: formatMessage({
                                                            id: "ui-br-publishers.publishers.contacts.select.label.phone",
                                                        }),
                                                    },
                                                    {
                                                        value: "DATA_BOX",
                                                        label: formatMessage({
                                                            id: "ui-br-publishers.publishers.contacts.select.label.dataBox",
                                                        }),
                                                    },
                                                ] })));
                                        } })),
                                React.createElement(Col, { xs: 4 },
                                    React.createElement(Controller, { control: control, name: "contacts.".concat(index, ".value"), render: function (_a) {
                                            var _b, _c, _d;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.contacts.field.label.contact", error: (_d = (_c = (_b = errors.contacts) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.message })));
                                        } })),
                                React.createElement(Col, { xs: 4 },
                                    React.createElement(Controller, { control: control, name: "contacts.".concat(index, ".info"), render: function (_a) {
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.contacts.field.label.info" })));
                                        } })),
                                React.createElement(Col, { xs: 2 },
                                    React.createElement(Button, { buttonStyle: "danger", onClick: function () { return removeContactAtIndex(index); }, style: { marginTop: "25px" } },
                                        React.createElement(FormattedMessage, { id: "ui-br-publishers.publishers.contacts.button.delete" }))))); }),
                            React.createElement(Button, { onClick: function () {
                                    return appendContact({
                                        type: "",
                                        value: "",
                                    }, { shouldFocus: false });
                                } },
                                React.createElement(FormattedMessage, { id: "ui-br-publishers.publishers.contacts.button.add" }))),
                        React.createElement(Accordion, { label: formatMessage({
                                id: "ui-br-publishers.publishers.accordion.label.alternativeNames",
                            }), open: accordionStatus.alternativeNames, onToggle: function () {
                                return setAccordionStatus(__assign(__assign({}, accordionStatus), { alternativeNames: !accordionStatus.alternativeNames }));
                            } },
                            alternativeNameFields.map(function (field, index) { return (React.createElement(Row, { key: field.id },
                                React.createElement(Col, { xs: 4 },
                                    React.createElement(Controller, { control: control, name: "alternativeNames.".concat(index, ".name"), defaultValue: field.name, render: function (_a) {
                                            var _b, _c, _d;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.alternativeNames.field.label.name", required: true, error: (_d = (_c = (_b = errors.alternativeNames) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.name) === null || _d === void 0 ? void 0 : _d.message })));
                                        } })),
                                React.createElement(Col, { xs: 4 },
                                    React.createElement(Controller, { control: control, name: "alternativeNames.".concat(index, ".nameSuffix"), defaultValue: field.nameSuffix, render: function (_a) {
                                            var _b, _c, _d;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.alternativeNames.field.label.nameSuffix", error: (_d = (_c = (_b = errors.alternativeNames) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.nameSuffix) === null || _d === void 0 ? void 0 : _d.message })));
                                        } })),
                                React.createElement(Col, { xs: 4 },
                                    React.createElement(Controller, { control: control, name: "alternativeNames.".concat(index, ".qualifier"), defaultValue: field.qualifier, render: function (_a) {
                                            var _b, _c, _d;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.general.field.label.qualifier", error: (_d = (_c = (_b = errors.alternativeNames) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.qualifier) === null || _d === void 0 ? void 0 : _d.message })));
                                        } })),
                                React.createElement(Col, { xs: 4 },
                                    React.createElement(AlternativeNameTypeSelect, { control: control, name: "alternativeNames.".concat(index, ".type"), autoComplete: "off" })),
                                React.createElement(Col, { xs: 2 },
                                    React.createElement(Controller, { control: control, name: "alternativeNames.".concat(index, ".nonPublic"), defaultValue: field.nonPublic, render: function (_a) {
                                            var field = _a.field;
                                            return (React.createElement(Checkbox, { checked: field.value, onChange: function (e) { return field.onChange(e.target.checked); }, label: formatMessage({
                                                    id: "ui-br-publishers.publishers.alternativeNames.checkbox.label.nonPublic",
                                                }) }));
                                        } })),
                                React.createElement(Col, { xs: 12 },
                                    React.createElement(Button, { buttonStyle: "danger", onClick: function () { return removeAlternativeNameAtIndex(index); }, style: { marginTop: "10px" } },
                                        React.createElement(FormattedMessage, { id: "ui-br-publishers.publishers.alternativeNames.button.delete" }))))); }),
                            React.createElement(Button, { onClick: function () {
                                    return appendAlternativeName({
                                        name: "",
                                        nameSuffix: "",
                                        qualifier: "",
                                        type: undefined,
                                        nonPublic: false,
                                    }, { shouldFocus: false });
                                } },
                                React.createElement(FormattedMessage, { id: "ui-br-publishers.publishers.alternativeNames.button.add" }))),
                        hasAtLeastOneRole(activeRoles, [
                            RoleEnum.PUBLISHER_ADMIN,
                            RoleEnum.AGENCY_WORKER,
                        ]) && (React.createElement(Accordion, { label: formatMessage({
                                id: "ui-br-publishers.publishers.accordion.label.guarantors",
                            }), id: "guarantors", open: accordionStatus.guarantors, onToggle: function () {
                                return setAccordionStatus(__assign(__assign({}, accordionStatus), { guarantors: !accordionStatus.guarantors }));
                            } },
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 12 },
                                    guarantorFields.map(function (guarantor, index) { return (React.createElement(Card, { key: guarantor.id, headerStart: React.createElement(FormattedMessage, { id: "ui-br-publishers.publishers.guarantors.card.header" }), roundedBorder: true },
                                        React.createElement(Row, null,
                                            React.createElement(Col, { xs: 12, md: 4 },
                                                React.createElement(Controller, { control: control, name: "guarantors.".concat(index, ".titlesBefore"), render: function (_a) {
                                                        var field = _a.field;
                                                        return (React.createElement(RecekTextField, __assign({ labelId: "ui-br-publishers.publishers.guarantors.field.label.titlesBefore" }, field, { autoComplete: "off", disabled: lockedGuarantors[index] ||
                                                                guarantorsLocked })));
                                                    } })),
                                            React.createElement(Col, { xs: 12, md: 4 },
                                                React.createElement(Controller, { control: control, name: "guarantors.".concat(index, ".firstName"), render: function (_a) {
                                                        var _b, _c, _d;
                                                        var field = _a.field;
                                                        return (React.createElement(RecekTextField, __assign({ labelId: "ui-br-publishers.publishers.general.field.label.firstName" }, field, { autoComplete: "off", required: true, disabled: lockedGuarantors[index] ||
                                                                guarantorsLocked, error: (_d = (_c = (_b = errors.guarantors) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.firstName) === null || _d === void 0 ? void 0 : _d.message })));
                                                    } })),
                                            React.createElement(Col, { xs: 12, md: 4 },
                                                React.createElement(Controller, { control: control, name: "guarantors.".concat(index, ".lastName"), render: function (_a) {
                                                        var _b, _c, _d;
                                                        var field = _a.field;
                                                        return (React.createElement(RecekTextField, __assign({ labelId: "ui-br-publishers.publishers.guarantors.field.label.lastName" }, field, { autoComplete: "off", required: true, disabled: lockedGuarantors[index] ||
                                                                guarantorsLocked, error: (_d = (_c = (_b = errors.guarantors) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.lastName) === null || _d === void 0 ? void 0 : _d.message })));
                                                    } })),
                                            React.createElement(Col, { xs: 12, md: 4 },
                                                React.createElement(Controller, { control: control, name: "guarantors.".concat(index, ".titlesAfter"), render: function (_a) {
                                                        var field = _a.field;
                                                        return (React.createElement(RecekTextField, __assign({ labelId: "ui-br-publishers.publishers.guarantors.field.label.titlesAfter" }, field, { autoComplete: "off", disabled: lockedGuarantors[index] ||
                                                                guarantorsLocked })));
                                                    } })),
                                            React.createElement(Col, { xs: 12, md: 4 },
                                                React.createElement(Controller, { control: control, name: "guarantors.".concat(index, ".email"), render: function (_a) {
                                                        var _b, _c, _d;
                                                        var field = _a.field;
                                                        return (React.createElement(RecekTextField, __assign({ labelId: "ui-br-publishers.publishers.guarantors.field.label.email" }, field, { autoComplete: "off", required: true, disabled: guarantorsLocked ||
                                                                disableEmailField[index], onChange: function (e) {
                                                                field.onChange(e);
                                                                unlockGuarantor(index);
                                                            }, onBlur: function () {
                                                                field.onBlur();
                                                                handleGuarantorEmailBlur(index);
                                                            }, error: (_d = (_c = (_b = errors.guarantors) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.email) === null || _d === void 0 ? void 0 : _d.message })));
                                                    } })),
                                            React.createElement(Col, { xs: 2 },
                                                React.createElement(Button, { buttonStyle: "danger", disabled: guarantorsLocked, onClick: function () { return removeGuarantorAtIndex(index); }, style: { marginTop: "25px" } },
                                                    React.createElement(FormattedMessage, { id: "ui-br-publishers.publishers.guarantors.button.delete" }))),
                                            React.createElement(Col, { xs: 6 },
                                                React.createElement(Row, null,
                                                    React.createElement("h3", null,
                                                        React.createElement(FormattedMessage, { id: "ui-br-publishers.publishers.guarantors.role" }))),
                                                React.createElement(Controller, { control: control, name: "guarantors.".concat(index, ".roles"), render: function (_a) {
                                                        var _b, _c, _d;
                                                        var _e = _a.field, name = _e.name, _f = _e.value, value = _f === void 0 ? [] : _f, onChange = _e.onChange;
                                                        // one role per guarantor; a dual role shows as PublisherAdmin (DB-520)
                                                        var selected = resolveGuarantorRole(value);
                                                        var pick = function (role) {
                                                            onChange(toggleGuarantorRole(value, role));
                                                        };
                                                        var canEditRoles = hasAtLeastOneRole(activeRoles, [
                                                            RoleEnum.AGENCY_WORKER,
                                                            RoleEnum.PUBLISHER_ADMIN,
                                                            RoleEnum.SUPERUSER,
                                                        ]);
                                                        return (React.createElement("fieldset", { name: name },
                                                            React.createElement(RadioButton, { label: formatMessage({
                                                                    id: "ui-br-publishers.publishers.guarantors.role.publisherAdmin",
                                                                }), value: "PublisherAdmin", checked: selected === "PublisherAdmin", onChange: function () { return pick("PublisherAdmin"); }, disabled: !canEditRoles }),
                                                            React.createElement(RadioButton, { label: formatMessage({
                                                                    id: "ui-br-publishers.publishers.guarantors.role.publisherGuarantor",
                                                                }), value: "PublisherGuarantor", checked: selected === "PublisherGuarantor", onChange: function () {
                                                                    return pick("PublisherGuarantor");
                                                                }, disabled: !canEditRoles }),
                                                            ((_c = (_b = errors.guarantors) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.roles) && (React.createElement("div", { style: {
                                                                    color: "#d00",
                                                                    marginTop: "0.5rem",
                                                                } }, errors.guarantors[index]
                                                                .roles.message ||
                                                                ((_d = errors.guarantors[index]
                                                                    .roles.root) === null || _d === void 0 ? void 0 : _d.message) ||
                                                                formatMessage({
                                                                    id: "ui-br-publishers.publishers.validation.guarantors.roles",
                                                                })))));
                                                    } }))))); }),
                                    React.createElement(Button, { type: "button", disabled: guarantorsLocked, onClick: function () {
                                            return appendGuarantor({
                                                id: "",
                                                firstName: "",
                                                lastName: "",
                                                email: "",
                                                contacts: [],
                                                titlesBefore: "",
                                                titlesAfter: "",
                                                user: {
                                                    sourceId: "",
                                                    firstName: "",
                                                    lastName: "",
                                                    email: "",
                                                    roles: [],
                                                },
                                                roles: ["PublisherGuarantor"],
                                            });
                                        }, style: { marginTop: "20px" } },
                                        React.createElement(FormattedMessage, { id: "ui-br-publishers.publishers.guarantors.button.add" })))))),
                        showWorkSpecSection && publisherData && workSpecLoaded ? (React.createElement(Accordion, { label: formatMessage({
                                id: "ui-br-publishers.publishers.accordion.label.workSpec",
                            }), open: accordionStatus.workSpecification, onToggle: function () {
                                return setAccordionStatus(__assign(__assign({}, accordionStatus), { workSpecification: !accordionStatus.workSpecification }));
                            } },
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 12 },
                                    React.createElement(Controller, { control: control, name: "workSpecification.title", render: function (_a) {
                                            var _b, _c;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.workSpec.field.label.title", required: true, error: (_c = (_b = errors.workSpecification) === null || _b === void 0 ? void 0 : _b.title) === null || _c === void 0 ? void 0 : _c.message, disabled: !isWorkSpecEditable })));
                                        } }))),
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 12 },
                                    React.createElement(Controller, { control: control, name: "workSpecification.subtitle", render: function (_a) {
                                            var _b, _c;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.workSpec.field.label.subTitle", error: (_c = (_b = errors.workSpecification) === null || _b === void 0 ? void 0 : _b.subtitle) === null || _c === void 0 ? void 0 : _c.message, disabled: !isWorkSpecEditable })));
                                        } }))),
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 12 },
                                    React.createElement(Controller, { control: control, name: "workSpecification.volumeNumber", render: function (_a) {
                                            var _b, _c;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.workSpec.field.label.volumeNumber", error: (_c = (_b = errors.workSpecification) === null || _b === void 0 ? void 0 : _b.volumeNumber) === null || _c === void 0 ? void 0 : _c.message, disabled: !isWorkSpecEditable })));
                                        } }))),
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 12 },
                                    React.createElement(Controller, { control: control, name: "workSpecification.partTitle", render: function (_a) {
                                            var _b, _c;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.workSpec.field.label.partName", error: (_c = (_b = errors.workSpecification) === null || _b === void 0 ? void 0 : _b.partTitle) === null || _c === void 0 ? void 0 : _c.message, disabled: !isWorkSpecEditable })));
                                        } }))),
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 12 },
                                    React.createElement("h3", null,
                                        React.createElement(FormattedMessage, { id: "ui-br-publishers.publishers.workSpec.title.authors" })))),
                            authorFields.map(function (author, index) { return (React.createElement(AuthorityAuthorRow, { key: author.id, author: watchedAuthors === null || watchedAuthors === void 0 ? void 0 : watchedAuthors[index], linkedPersonIds: personIdsLinkedElsewhere(watchedAuthors, index), searchAuthors: searchAuthors, disabled: !isWorkSpecEditable, onPick: function (picked) {
                                    return setValue("workSpecification.authors.".concat(index), picked, {
                                        shouldValidate: true,
                                        shouldDirty: true,
                                    });
                                }, onClear: function () {
                                    return setValue("workSpecification.authors.".concat(index), unlinkedAuthor(), {
                                        shouldValidate: true,
                                        shouldDirty: true,
                                    });
                                }, onRemove: function () { return removeAuthor(index); }, renderNameField: function (name, readOnly) { return (React.createElement(Controller, { control: control, name: "workSpecification.authors.".concat(index, ".").concat(name), render: function (_a) {
                                        var _b, _c, _d, _e;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, field, { readOnly: readOnly, autoComplete: "off", labelId: "ui-br-publishers.publishers.workSpec.field.label.authors.".concat(name), error: (_e = (_d = (_c = (_b = errors.workSpecification) === null || _b === void 0 ? void 0 : _b.authors) === null || _c === void 0 ? void 0 : _c[index]) === null || _d === void 0 ? void 0 : _d[name]) === null || _e === void 0 ? void 0 : _e.message, disabled: !isWorkSpecEditable })));
                                    } })); } })); }),
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 12 },
                                    React.createElement(Button, { onClick: function () { return appendAuthor(unlinkedAuthor()); }, disabled: !isWorkSpecEditable },
                                        React.createElement(FormattedMessage, { id: "ui-br-publishers.publishers.workSpec.button.authors.add" })))),
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 6 },
                                    React.createElement(Controller, { control: control, name: "workSpecification.publicationDate", render: function (_a) {
                                            var _b, _c;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.workSpec.datePicker.label.publicationDate", error: (_c = (_b = errors.workSpecification) === null || _b === void 0 ? void 0 : _b.publicationDate) === null || _c === void 0 ? void 0 : _c.message, placeholder: "DD.MM.YYYY / MM.YYYY / YYYY", disabled: !isWorkSpecEditable })));
                                        } })),
                                React.createElement(Col, { xs: 6 },
                                    React.createElement(Controller, { control: control, name: "workSpecification.editionNumber", render: function (_a) {
                                            var _b, _c;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.workSpec.field.label.releaseOrder", error: (_c = (_b = errors.workSpecification) === null || _b === void 0 ? void 0 : _b.editionNumber) === null || _c === void 0 ? void 0 : _c.message, disabled: !isWorkSpecEditable })));
                                        } }))),
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 12 },
                                    React.createElement(Controller, { control: control, name: "workSpecification.coEditionWith", render: function (_a) {
                                            var _b, _c;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.workSpec.field.label.publishedInConjunction", error: (_c = (_b = errors.workSpecification) === null || _b === void 0 ? void 0 : _b.coEditionWith) === null || _c === void 0 ? void 0 : _c.message, disabled: !isWorkSpecEditable })));
                                        } }))),
                            React.createElement(WorkSpecFormatFields, { key: "workspec-formats-".concat(publisherData === null || publisherData === void 0 ? void 0 : publisherData.id), workSpecification: watch("workSpecification"), errors: errors.workSpecification, onChange: applyWorkSpecFormatFields, disabled: !isWorkSpecEditable, otherFormats: React.createElement(React.Fragment, null,
                                    React.createElement(Row, null,
                                        React.createElement(Col, { xs: 12 },
                                            React.createElement("h3", null,
                                                React.createElement(FormattedMessage, { id: "ui-br-publishers.publishers.workSpec.select.label.ebookFormats.other" })))),
                                    otherFormatFields.map(function (formatField, index) { return (React.createElement(Row, { key: formatField.id },
                                        React.createElement(Col, { xs: 10 },
                                            React.createElement(Controller, { control: control, name: "workSpecification.otherFormats.".concat(index, ".format"), render: function (_a) {
                                                    var _b, _c, _d, _e;
                                                    var field = _a.field;
                                                    return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.workSpec.select.label.ebookFormats.otherFormat", error: (_e = (_d = (_c = (_b = errors.workSpecification) === null || _b === void 0 ? void 0 : _b.otherFormats) === null || _c === void 0 ? void 0 : _c[index]) === null || _d === void 0 ? void 0 : _d.format) === null || _e === void 0 ? void 0 : _e.message, disabled: !isWorkSpecEditable })));
                                                } })),
                                        React.createElement(Col, { xs: 2 },
                                            React.createElement(Button, { buttonStyle: "danger", onClick: function () { return removeOtherFormat(index); }, style: { marginTop: "25px" }, disabled: !isWorkSpecEditable },
                                                React.createElement(FormattedMessage, { id: "ui-br-publishers.publishers.workSpec.button.delete" }))))); }),
                                    React.createElement(Row, null,
                                        React.createElement(Col, { xs: 12 },
                                            React.createElement(Button, { onClick: function () {
                                                    return appendOtherFormat({ format: "" }, { shouldFocus: false });
                                                }, disabled: !isWorkSpecEditable },
                                                React.createElement(FormattedMessage, { id: "ui-br-publishers.publishers.workSpec.button.ebookFormats.add" }))))) }))) : null,
                        hasRole(activeRoles, RoleEnum.AGENCY_WORKER) ? (React.createElement(Accordion, { label: formatMessage({
                                id: "ui-br-publishers.publishers.accordion.label.comments",
                            }), open: accordionStatus.comments, onToggle: function () {
                                return setAccordionStatus(__assign(__assign({}, accordionStatus), { comments: !accordionStatus.comments }));
                            } },
                            React.createElement(Controller, { control: control, name: "internalComment", render: function (_a) {
                                    var _b;
                                    var field = _a.field;
                                    return (React.createElement(RecekTextArea, __assign({ labelId: "ui-br-publishers.publishers.comments.textArea.label.internalComment" }, field, { autoComplete: "off", error: (_b = errors.internalComment) === null || _b === void 0 ? void 0 : _b.message })));
                                } }))) : null))),
            React.createElement(DuplicateDetailPane, { selectedDuplicatePublisher: selectedDuplicatePublisher, onClose: onClose }))));
};
export default PublisherEdit;
